import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "./clock.js";
import n from "./Error.js";
import { once as e } from "./events.js";
import r from "./Logger.js";
import { isSome as o, isNone as i, assumeNonNull as u, removeMaybe as c } from "./maybe.js";

function s(t) {
  return Promise.all(t);
}

function l(t, n) {
  var e = t.slice();
  return Promise.all(t.map(function (t, e) {
    return n(t, e);
  })).then(function (t) {
    return e.filter(function (n, e) {
      return t[e];
    });
  });
}

function f(t) {
  return new Promise(function (n, e) {
    try {
      t(n, e);
    } catch (r) {
      Promise.resolve().then(function () {
        return e(r);
      });
    }
  });
}

function m() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Aborted";
  return new n("AbortError", t);
}

function h(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Aborted";
  if (p(t)) throw m(n);
}

function a(t) {
  return o(t) ? "aborted" in t ? t : t.signal : t;
}

function p(t) {
  var n = a(t);
  return o(n) && n.aborted;
}

function b(t) {
  if (g(t)) throw t;
}

function w(t) {
  if (!g(t)) throw t;
}

function v(t, n) {
  var r = a(t);

  if (!i(r)) {
    if (!r.aborted) return e(r, "abort", function () {
      return n();
    });
    n();
  }
}

function P(t, n) {
  var r = a(t);
  if (!i(r)) return h(r), e(r, "abort", function () {
    return n(m());
  });
}

function d(t, n) {
  var e = a(n);
  return i(e) ? t : new Promise(function (e, r) {
    var o = v(n, function () {
      return r(m());
    });

    var i = function i() {
      return o = c(o);
    };

    t.then(i, i), t.then(e, r);
  });
}

function j(t, e) {
  return Promise.race([t, x(e).then(function () {
    throw new n("timeout", "Did not resolve within ".concat(e, " milliseconds"));
  })]);
}

function g(t) {
  return t && "AbortError" === t.name;
}

function y(t) {
  return t.catch(function (t) {
    if (!g(t)) throw t;
  });
}

function A(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.getLogger("esri");
  return t.catch(function (t) {
    g(t) || n.error(t);
  });
}

function T() {
  var t = null;
  var n = new Promise(function (n, e) {
    t = {
      promise: void 0,
      resolve: n,
      reject: e
    };
  });
  return t.promise = n, t;
}

function E(t) {
  if (!t) return;

  if ("function" != typeof t.forEach) {
    var _n = Object.keys(t);

    return E(_n.map(function (n) {
      return t[n];
    })).then(function (t) {
      var e = {};
      return _n.forEach(function (n, r) {
        return e[n] = t[r];
      }), e;
    });
  }

  var n = t;
  return f(function (t) {
    var e = [];
    var r = n.length;
    0 === r && t(e), n.forEach(function (n) {
      var o = {
        promise: n || Promise.resolve(n)
      };
      e.push(o), o.promise.then(function (t) {
        o.value = t;
      }).catch(function (t) {
        o.error = t;
      }).then(function () {
        --r, 0 === r && t(e);
      });
    });
  });
}

function C(t) {
  return E(t).then(function (t) {
    return t.filter(function (t) {
      return !!t.value;
    }).map(function (t) {
      return t.value;
    });
  });
}

function k(t) {
  return Promise.reject(t);
}

function L(t) {
  return Promise.resolve(t);
}

function x(t, n, e) {
  var r = new AbortController();
  return v(e, function () {
    return r.abort();
  }), new Promise(function (e, o) {
    var i = setTimeout(function () {
      i = 0, e(n);
    }, t);
    v(r, function () {
      i && (clearTimeout(i), o(m()));
    });
  });
}

function D(t, e, r, o) {
  var i = r && "abort" in r ? r : null;
  null != o || i || (o = r);
  var u = setTimeout(function () {
    u = 0, i && i.abort();
  }, e);

  var c = function c() {
    return o || new n("promiseUtils:timeout", "The wrapped promise did not resolve within " + e + " ms");
  };

  return t.then(function (t) {
    if (0 === u) throw c();
    return clearTimeout(u), t;
  }, function (t) {
    throw clearTimeout(u), 0 === u ? c() : t;
  });
}

function O(t) {
  return t && "function" == typeof t.then;
}

function U(t) {
  return $(t) ? t : Promise.resolve(t);
}

function $(t) {
  return t && "object" == typeof t && "then" in t && "function" == typeof t.then;
}

function q(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  var e,
      r,
      o,
      i,
      c = null;

  var s = function s() {
    for (var _len = arguments.length, l = new Array(_len), _key = 0; _key < _len; _key++) {
      l[_key] = arguments[_key];
    }

    if (e) {
      r = l, i && i.reject(m()), i = T();

      var _t = u(i.promise);

      if (c) {
        var _t2 = c;
        c = null, _t2.abort();
      }

      return _t;
    }

    if (o = i || T(), i = null, n > 0) {
      var _r = new AbortController();

      e = U(t.apply(void 0, l.concat([_r.signal])));
      var _o = e;
      x(n).then(function () {
        e === _o && (i ? _r.abort() : c = _r);
      });
    } else e = 1, e = U(t.apply(void 0, l));

    var f = function f() {
      var t = r;
      r = o = e = c = null, null != t && s.apply(void 0, _toConsumableArray(t));
    },
        h = e,
        a = o;

    return h.then(f, f), h.then(a.resolve, a.reject), u(a.promise);
  };

  return s;
}

function z() {
  var n, e;

  var r = new Promise(function (t, r) {
    n = t, e = r;
  }),
      o = function o(t) {
    n(t);
  };

  return o.resolve = function (t) {
    return n(t);
  }, o.reject = function (t) {
    return e(t);
  }, o.timeout = function (n, e) {
    return t.setTimeout(function () {
      return o.reject(e);
    }, n);
  }, o.promise = r, o;
}

function B(t, n) {
  return t.then(n, n);
}

function F(t, n) {
  var e,
      r = new AbortController();
  var i = t(r.signal);
  var u = {
    promise: i,
    finished: !1,
    abort: function abort() {
      r && (r.abort(), r = null);
    }
  };

  var c = function c() {
    u && (u.finished = !0, u = null), o(e) && (e.remove(), e = null), r = null;
  };

  return i.then(c, c), e = v(n, function () {
    o(u) && u.abort();
  }), u;
}

function G(t) {
  return Promise.resolve().then(function () {
    h(t);
  });
}

export { x as after, s as all, B as always, f as create, m as createAbortError, T as createDeferred, z as createResolver, F as createTask, q as debounce, E as eachAlways, C as eachAlwaysValues, l as filter, y as ignoreAbortErrors, g as isAbortError, p as isAborted, $ as isPromise, O as isPromiseLike, A as logOnError, v as onAbort, P as onAbortOrThrow, k as reject, L as resolve, b as throwIfAbortError, h as throwIfAborted, w as throwIfNotAbortError, D as timeout, G as waitTick, U as when, d as whenOrAbort, j as whenOrTimeout };